<script>
import Repositories from '@/repositories';
const ItemSuppliersRepository = Repositories.get('itemsuppliers');
const OrderItemsRepository = Repositories.get('orderitems');
import scrollMixin from '@/mixins/scrollWheelMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import dateMixin from '@/mixins/dateMixin';
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import {
  required,
  minLength,
  minValue,
  integer,
} from 'vuelidate/lib/validators';
import OrderItemReservations from './order-item-reservations.vue';

export default {
  components: {
    Loading,
    Tooltip,
    OrderItemReservations,
  },
  props: {
    orderItem: { required: true, type: Object },
  },
  mixins: [dateMixin, scrollMixin],
  data() {
    return {
      itemSupplier: null,
      isLoading: false,
      itemSupplierForm: {
        code: '',
        name: '',
      },
      internalOrderItem: null,
      quantityEdition: {
        isEditingQuantity: false,
        isLoadingEdition: false,
      },
      totalUnits: 0,
    };
  },
  methods: {
    modalHidden() {
      this.internalOrderItem = null;
      this.$emit('modal-closed');
    },
    async modalShown() {
      this.$v.itemSupplierForm.$reset();
      this.isLoading = true;

      this.itemSupplier = null;
      this.itemSupplierForm.isLoading = false;
      this.itemSupplierForm.code = '';
      this.itemSupplierForm.name = '';

      this.internalOrderItem = { ...this.orderItem };

      await this.loadData(this.internalOrderItem == null);
    },
    async loadData(reloadOrderItem = true) {
      try {
        this.isLoading = true;

        let { data } = await ItemSuppliersRepository.get(
          this.internalOrderItem.itemSupplierIdPublic
        );

        this.itemSupplier = data;

        if (reloadOrderItem || this.internalOrderItem == null) {
          let {
            data,
          } = await OrderItemsRepository.customREST.getWithWorkOrderItemOrderItems();
          this.internalOrderItem = data;
          this.$emit('order-item-updated', this.internalOrderItem);
        }

        this.totalUnits = this.internalOrderItem.totalUnits;

        this.itemSupplierForm.code = this.internalOrderItem.gridItemCode;
        this.itemSupplierForm.name = this.internalOrderItem.gridItemName;
      } catch (error) {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }
    },
    orderItemUpdated(orderItem) {
      this.internalOrderItem = orderItem;
      this.$emit('order-item-updated', this.internalOrderItem);
    },
    async submitItemForm(updateGlobally = false) {
      this.$v.itemSupplierForm.$touch();
      if (!this.$v.itemSupplierForm.$invalid) {
        try {
          this.isLoading = true;

          if (updateGlobally) {
            let payload = { ...this.itemSupplier, ...this.itemSupplierForm };
            await ItemSuppliersRepository.update(
              payload,
              this.itemSupplier.idPublic
            );

            this.internalOrderItem.editedItemCode = null;
            this.internalOrderItem.editedItemName = null;
          } else {
            this.internalOrderItem.editedItemCode = this.itemSupplierForm.code;
            this.internalOrderItem.editedItemName = this.itemSupplierForm.name;
          }

          await OrderItemsRepository.update(
            this.internalOrderItem,
            this.internalOrderItem.idPublic
          );

          this.internalOrderItem.itemSupplierCode = this.itemSupplierForm.code;
          this.internalOrderItem.itemSupplierName = this.itemSupplierForm.name;

          this.$emit('order-item-updated', this.internalOrderItem);

          this.$toast.successToast(this.$t('general.success'));
        } catch (error) {
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
    startEditingQuantity() {
      this.quantityEdition.isEditingQuantity = true;
      this.$nextTick(() => {
        this.$v.$reset();
        this.$nextTick(() => {
          const editInput = this.$refs.editQuantityInput;
          editInput.focus();
        });
      });
    },
    cancelEdition() {
      this.$v.$reset();
      this.quantityEdition.isEditingQuantity = false;
    },
    saveQuantity() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.quantityEdition.isLoadingEdition = true;

        let payload = {
          totalUnits: this.toFloat(this.totalUnits),
          totalQuantity: this.toFloat(
            this.totalUnits *
              this.internalOrderItem.itemSupplierOrderUnitQuantity
          ),
        };

        OrderItemsRepository.actions
          .updateQuantity(payload, this.internalOrderItem.idPublic)
          .then(() => {
            this.quantityEdition.isLoadingEdition = false;
            this.quantityEdition.isEditingQuantity = false;

            this.internalOrderItem.totalUnits = payload.totalUnits;
            this.internalOrderItem.totalQuantity = payload.totalQuantity;

            this.$emit('order-item-updated', this.internalOrderItem);
          })
          .catch((error) => {
            this.quantityEdition.isLoadingEdition = false;
            if (error.response.status == 409) {
              this.$toast.warningToast(
                this.$t('errors.wasDesyncedTryAgainBulk')
              );
              this.$emit('reload-item');
            } else {
              this.$toast.errorToast(this.$t('errors.errorLoading'));
            }
          });
      }
    },
    wheelInput(event) {
      this.totalUnits = this.scrollMixinEvent(
        event,
        this.totalUnits,
        this.minQuantity
      );
    },
  },
  computed: {
    availableQuantity() {
      if (this.internalOrderItem == null) {
        return 0;
      }

      let {
        receivedQuantity,
        receivedReservedQuantity,
        totalQuantity,
        reservedQuantity,
      } = this.internalOrderItem;
      return (
        totalQuantity -
        receivedQuantity -
        reservedQuantity +
        receivedReservedQuantity
      );
    },
    minQuantity() {
      if (this.internalOrderItem == null) {
        return 0;
      }

      let {
        receivedQuantity,
        receivedReservedQuantity,
        reservedQuantity,
        itemSupplierOrderUnitQuantity,
      } = this.internalOrderItem;

      let total =
        receivedQuantity + receivedReservedQuantity + reservedQuantity;

      if (itemSupplierOrderUnitQuantity <= 0) {
        itemSupplierOrderUnitQuantity = 0;
      }

      let unitQuantity = Math.ceil(total / itemSupplierOrderUnitQuantity);

      return Math.max(
        this.internalOrderItem.itemSupplierOrderMinimumQuantity,
        unitQuantity
      );
    },
  },
  validations() {
    if (this.internalOrderItem != null) {
      if (this.internalOrderItem.quantityType == 'unitary') {
        return {
          totalUnits: {
            required,
            minValue: minValue(this.minQuantity),
            integer,
          },
          itemSupplierForm: {
            code: { required, minLength: minLength(1) },
            name: { required, minLength: minLength(1) },
          },
        };
      } else {
        return {
          totalUnits: {
            required,
            minValue: minValue(this.minQuantity),
          },
          itemSupplierForm: {
            code: { required, minLength: minLength(1) },
            name: { required, minLength: minLength(1) },
          },
        };
      }
    } else {
      return {
        totalUnits: { required, minValue: minValue(0) },
        itemSupplierForm: {
          code: { required, minLength: minLength(1) },
          name: { required, minLength: minLength(1) },
        },
      };
    }
  },
};
</script>

<template>
  <div>
    <b-modal
      id="edit-order-items-modal"
      size="lg"
      hide-footer
      :title="$t('items.item')"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="danger"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <b-form-group
        :label="$t('general.code')"
        label-for="item-supplier-code-input"
      >
        <b-form-input
          id="item-supplier-code-input"
          ref="itemNameRef"
          :class="{
            'is-invalid': $v.itemSupplierForm.code.$error,
          }"
          v-model="itemSupplierForm.code"
          :placeholder="$t('general.code')"
        >
        </b-form-input>
        <Tooltip :validations="$v.itemSupplierForm.code" />
      </b-form-group>

      <b-form-group
        :label="$t('general.name')"
        label-for="item-supplier-name-input"
      >
        <b-form-input
          id="item-supplier-name-input"
          ref="itemNameRef"
          :class="{
            'is-invalid': $v.itemSupplierForm.name.$error,
          }"
          v-model="itemSupplierForm.name"
          :placeholder="$t('general.name')"
        >
        </b-form-input>
        <Tooltip :validations="$v.itemSupplierForm.name" />
      </b-form-group>

      <b-button variant="primary" @click="submitItemForm(false)">{{
        $t('orders.updateThisOrder')
      }}</b-button>
      <b-button
        variant="secondary"
        class="ml-2"
        @click="submitItemForm(true)"
        >{{ $t('orders.updateItemGlobally') }}</b-button
      >

      <div class="quantity-group mt-2">
        <h4>
          {{ $t('items.quantity') }}
        </h4>

        <div v-if="!quantityEdition.isEditingQuantity" class="quantity-number">
          {{ internalOrderItem == null ? 0 : internalOrderItem.totalUnits }}
          <i
            class="fas fa-pencil-alt text-primary pl-2 pr-2"
            @click="startEditingQuantity"
            style="cursor: pointer; font-size: 1.2em"
          ></i>
        </div>
        <div
          v-else
          class="quantity-number flex-right-center-align"
          style="position: relative"
        >
          <b-input
            :class="{
              'is-invalid': $v.totalUnits.$error,
            }"
            ref="editQuantityInput"
            v-model="totalUnits"
            style="font-size: 1.1em; max-width: 150px"
            @wheel.prevent="wheelInput($event)"
            @keydown.escape.prevent.stop="cancelEdition"
            @keydown.enter.prevent="saveQuantity"
            type="text"
          ></b-input>
          <Tooltip :validations="$v.totalUnits" />

          <i
            id="popover-button"
            :class="
              quantityEdition.isLoadingEdition
                ? 'fas fa-spinner fa-spin text-warning ml-3 mr-2'
                : 'fas fa-check text-success pl-3 pr-2'
            "
            @click="saveQuantity"
            style="cursor: pointer; font-size: 1.5em"
          ></i>
        </div>
      </div>

      <OrderItemReservations
        v-if="internalOrderItem != null"
        class="mt-2"
        :key="internalOrderItem.idPublic"
        :orderItem="internalOrderItem"
        :availableQuantity="availableQuantity"
        @order-item-updated="orderItemUpdated"
      />
    </b-modal>
  </div>
</template>
